import React from 'react'
import ReactDOM from 'react-dom'

import App from './js/App'
import './js/i18n'

ReactDOM.render(<App />, document.getElementById('app'))
